import React, { Component } from 'react';
import connect from 'react-redux/lib/connect/connect';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { CircularProgress } from '../../utils/materialUI';

import { validateEmail } from '../../utils/validators';
import { subscribe } from '../../actions/SubscriptionActions';
import SUBSCRIBE from '../../assets/images/widgets/subscribe.webp';

class SubscriptionWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            unfilled: false,
            email: '',
        };
    }

    handleChange = (data) => {
        data.preventDefault();
        const name = data.target.name;
        this.setState({ [name]: data.target.value });
    };

    emailValidation = (event, error) => {
        if (!(this.state.email)) {
            return;
        }
        event.preventDefault();
        this.setState({
            email: event.target.value,
            emailError: !!error,
        });
    };

    handleSubmit = () => {
        const { email } = this.state;

        if (!(email)) {
            this.setState({
                unfilled: true,
                submitted: false,
            });
            return;
        }

        if (this.state.emailError) {
            this.setState({
                unfilled: false,
                submitted: false,
            });
            return;
        }

        this.props.subscribe(email);

        this.setState({
            email: '',
            unfilled: false,
            submitted: true,
            emailError: false,
        });
    };

    render() {
        const { subscription } = this.props;
        const subscriptionSuccessful = !subscription.isLoading && this.state.submitted && !subscription.error;

        return (
            <div>
                <div>
                    <LazyLoad>
                        <img className="side-bar-image" src={SUBSCRIBE} alt="Subscribe" />
                    </LazyLoad>
                </div>
                <fieldset id="subscribe">
                    {
                        subscription.isLoading ?
                            <div className="center">
                                <CircularProgress color="inherit" />
                            </div> : ''
                    }
                    {
                        subscription.error
                        && <div className="auth-message">{subscription.error.email ? subscription.error.email[0] : 'Subscription Failed!'}</div>
                    }
                    {
                        subscriptionSuccessful
                        && (
                            <div className="flashMessage">
                                JazakAllah for your email subscription.Please check your email
                            </div>
                        )}
                    {
                        this.state.unfilled
                        && <div className="auth-message">Please provide email.</div>
                    }
                    {
                        this.state.emailError
                        && <div className="auth-message">Please enter a valid email address.</div>
                    }
                    <input
                        type="text"
                        id="field-subscribe"
                        placeholder="E-mail"
                        name="email"
                        size="20"
                        onChange={this.handleChange}
                        onBlur={e => this.emailValidation(e, validateEmail(this.state.email))}
                        value={this.state.email}
                        style={{ borderColor: this.state.emailError ? 'red' : null }}
                    />
                    <button
                        className="subscribe"
                        type="submit"
                        onClick={this.handleSubmit}
                    >
                        Subscribe
                    </button>
                </fieldset>
            </div>
        );
    }
}

SubscriptionWidget.propTypes = {
    subscription: PropTypes.object.isRequired,
    subscribe: PropTypes.func.isRequired,
};

const mapStateToProps = ({ subscriptionReducer }) => ({
    subscription: subscriptionReducer,
});


export default connect(mapStateToProps, {
    subscribe,
})(SubscriptionWidget);
